export default __webpack_public_path__ + "static/media/winnings.8ea9ff83.mp4";